// Konfiguration der Statistik-Datensätze
// Layer-Namen der historischen Baumbestände im GeoServer

export const STATISTIK_DATASETS = {
  2019: "treesimportold20240822_062154",
  2020: "treesimportold20240822_062329",
  2021: "treesimportold20240822_062414",
  2022: "treesimportold20240822_062457",
  2024: "treesimport_20260828",
  2025: "treeclimate_bak_20250916",
  2026: "treesimport",
};

export const STATISTIK_AKTUELL = STATISTIK_DATASETS[2026];
